import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, map } from 'rxjs';
import { BackendListModel } from 'src/app/models/common/list.model';
import { CurrencyModel } from 'src/app/models/currency_master_model/currency';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { CurrencyMasterApiService } from 'src/app/services/domain_code/currency-master-api.service';
import { SuccessBoxComponent } from 'src/app/components';
import { WarningBoxComponent } from 'src/app/components';
import { FailureBoxComponent } from 'src/app/components';
import { MatDialog } from '@angular/material/dialog';
import { AddCurrencyComponent } from '../../snackbars/add-currency/add-currency.component';
import { Router } from '@angular/router';

@Component({
  selector: 'logzy-currency-form',
  templateUrl: './currency-form.component.html',
  styleUrls: ['./currency-form.component.scss']
})
export class CurrencyFormComponent implements OnInit {

  @Input()
  isEditable: boolean = true;

  @Output()
  isEditableChange = new EventEmitter<boolean>();

  @Input()
  onClose = new EventEmitter<boolean>();
  @Output()
  closeForm = new EventEmitter<CurrencyModel>();
  wasedit: boolean;
  open: string = "sidepanel";
  canvas: string = "Canvas";
  @ViewChild('countryInput') countryInput!: ElementRef<HTMLInputElement>;


  @Input()
  currencyObject: CurrencyModel;
  defaultCurrency: CurrencyModel = {
    id: null,
    updated_at: null,
    created_at: null,
    is_active: true,
    currency_code: null,
    description: null,
    created_by: null,
    updated_by: null,
    countries: []
  }
  dd_currency: BackendListModel<CurrencyModel>;
  dd_country: BackendListModel<CurrencyModel>;
  currencyMaster_url = ApiRoutes.CurrencyMaster;
  country_url = ApiRoutes.Geo;
  @Input()
  errorObj: any = {};

  @Output()
  onCurrencyCreated = new EventEmitter<CurrencyModel>();
  errorMessage: [];
  titlecasePipe: any;
  constructor(private _currencymasterservice: CurrencyMasterApiService, private _snackBar: MatSnackBar, public dialog: MatDialog, private router: Router
  ) { }

  ngOnInit(): void {
    // this.getCountries();
    // this.getCurrency();
    this.resetComponent();
  }

  getCurrency() {
    return this._currencymasterservice.getAllCurrency().pipe(
      map(response => {
        if (!response) {
        } else {
          this.dd_currency = response;
        }
      }),
      catchError(error => {
        console.log("lease", error);
        return error;
      })
    );
  }

  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      return error;
    }
  }
  getAllCountryMapping() {
    return this._currencymasterservice.getAllCountry().pipe(
      map(response => {
        if (!response) {
          console.log("Could not fetch");
        } else {
          this.dd_country = response;
        }
      }),
      catchError(error => {
        console.log("lease", error);
        return error;
      })
    );
  }

  getCountries() {
    this._currencymasterservice.getAllCurrencyCountry().subscribe({
      next: response => {
        this.dd_country = response;
      },
      error: error => {
        console.log(error)
        return error;
      }
    })
  }

  editCurrency(element) {
    this.currencyObject = JSON.parse(JSON.stringify(element));
    this.errorObj = [null];
  }

  wasEdit() {
    this.isEditable = true;
    this.isEditableChange.emit(true);
    this.errorObj = {};
    console.log("Errors", this.errorObj)
  }

  _postCurrency(data) {
    data['countries'] = this.getIdListFromObjList(data.countries);
    this._currencymasterservice.postCurrency(data).subscribe({
      next: response => {
        if (data['is_active'] == false) {
          this._snackBar.openFromComponent(AddCurrencyComponent, {
            duration: 1000,
            panelClass: ['success-snackbar'],
            data: { description: `${data.is_active == true ? '' : 'Currency delete successfully'}` }
          });
        } else {
          this._snackBar.openFromComponent(AddCurrencyComponent, {
            duration: 1000,
            panelClass: ['success-snackbar'],
            data: { description: `${data.is_active == false ? '' : 'Currency Added successfully'}` }
          });
        }
        this.getCountries();
        this.closeCurrencySidePanel(response);

        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    });
  }

  _putCurrency(id, data) {
    data['countries'] = this.getIdListFromObjList(data.countries);
    console.log("data.countries", data.countries)
    this._currencymasterservice.updateCurrency(id, data).subscribe({
      next: response => {
        if (data['is_active'] == false) {
          this._snackBar.openFromComponent(AddCurrencyComponent, {
            duration: 3000,
            panelClass: ['success-snackbar'],
            data: { description: `${data.is_active == true ? '' : 'Currency delete successfully'}` }
          });
        } else {
          this._snackBar.openFromComponent(AddCurrencyComponent, {
            duration: 3000,
            panelClass: ['success-snackbar'],
            data: { description: `${data.is_active == false ? '' : 'Currency Updated successfully'}` }
          });
        }
        this.getCountries();
        this.closeCurrencySidePanel(response);
        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    });
  }

  getIdListFromObjList(objList: any[]) {
    let objIds = []
    for (let obj of objList) {
      objIds.push(obj.id);
    }
    return objIds;
  }

  saveCurrency() {
    let payload = { ...this.currencyObject };
    console.log("Testing", payload)
    if (payload.id != null) {
      this._putCurrency(payload.id, payload);
    } else {
      this._postCurrency(payload);

    }
  }
  addUser(className: string) {
    this._snackBar.openFromComponent(AddCurrencyComponent, {
      duration: 2000,
      panelClass: [className]
    });
  }
  resetComponent() {
    this.errorObj = {};
    this.currencyObject = { ...this.defaultCurrency };
  }

  closeCurrencySidePanel(currencyObject: CurrencyModel) {
    this.isEditable = false;
    this.closeForm.emit(currencyObject);
    this.resetComponent();
    this.countryInput.nativeElement.style.width = "0";
    this.router.navigate([], {
      queryParams: {
        'id': null,
      },
      queryParamsHandling: 'merge'
    });
  }


  transformCurrency() {
    this.currencyObject['currency_code'] = this.titlecasePipe.transform(this.currencyObject['currency_code']);
  }

//For Edit Currency
  clickedCurrencyToEdit;
  editCurrencyMaster(element) {
    this.clickedCurrencyToEdit = element;
    this.openWarningDialogEdit("Are you sure Edit this Currency?", "No", "Yes");
  }
  openWarningDialogEdit(label: string, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      data: { subTitle: label, parent: this, label1: action1, label2: action2, negativeAction: this.negativeResponseEdit, positiveAction: this.positiveResponseEdit }
    })
    dialogRef.afterClosed();
  }

  positiveResponseEdit(parent) {
    parent.editCurrency(parent.clickedCurrencyToEdit);
  }

  negativeResponseEdit(parent) {
    parent.clickedCurrencyToEdit = null;
    return;
  }

  //For inactive Currency
  clickedCurrencyToinActive;
  inActiveCurrencyMaster(element) {
    this.clickedCurrencyToinActive = element;
    this.openWarningDialoginActive("Making Currency Inactive will SOFT Delete it, which might impact some transactions. Do you still want to continue?", "No", "Yes");
  }
  openWarningDialoginActive(label: string, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      data: { subTitle: label, parent: this, label1: action1, label2: action2, negativeAction: this.negativeResponseinActive, positiveAction: this.positiveResponseinActive }
    })
    dialogRef.afterClosed();
  }

  positiveResponseinActive(parent) {
    parent.currencyObject.is_active = false;
  }

  negativeResponseinActive(parent) {
    parent.currencyObject.is_active = true;
    return;
  }
}
